import { render } from "./ActivateInvite.vue?vue&type=template&id=39f8c020&scoped=true"
import script from "./ActivateInvite.vue?vue&type=script&lang=js"
export * from "./ActivateInvite.vue?vue&type=script&lang=js"

import "@/assets/styles/login.css?vue&type=style&index=0&id=39f8c020&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f8c020"]])

export default __exports__